import * as _desktop from "./desktop";
import * as _generic from "./generic";
import * as _mobile from "./mobile";

export const generic = _generic;
export const mobile = _mobile;
export const desktop = _desktop;
